//axiosInstance.js
//导入axios
import axios from 'axios'
import { Message } from 'element-ui'
import { myLogin } from '../utils/autoLogin'
import store from '@/store'
import router from '../router/index'
//使用axios下面的create([config])方法创建axios实例，其中config参数为axios最基本的配置信息。
const instance = axios.create({
  baseURL: '/apis', //请求后端数据的基本地址，自定义
  // timeout: 5000                   //请求超时设置，单位ms
})
/* 请求拦截 */
instance.interceptors.request.use(config => {
  let token = sessionStorage.getItem('token')
  config.headers['token'] = token
  return config
}, err => err)
/* 响应拦截 */
instance.interceptors.response.use(async res => {
  // 5002:token为空 5003:无效token 5004:无权限
  // if ([5002, 5003].includes(res.data.code)) {
  //   // 排除部分接口
  //   if (['/sql/access/getUserInfo'].includes(res.config.url) == false) {
  //     await myLogin()
  //   }
  // } else
  if ([401, 403, 5004].includes(res.data.code)) {
    console.log(res);
    if (['/parse','/login/web/ip'].includes(res.config.url) == false) {
      await myLogin()
    }
    // router.push('/login?redirect=' + encodeURIComponent(router.currentRoute.value.fullPath))
    /* router.push('/login' )
    Message({ message: res.data.data || res.data.message, type: 'warning' }) */
  }
  if (res.data.success) {
    store.isCreatePage = true
  }

  return res.data
}, err => {
  Message({ message: err.message, type: 'error' })
  return err
})
//导出我们建立的axios实例模块，ES6 export用法
export default instance
